import React, { Suspense } from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { LoadingIndicator } from "../components/LoadingNavigator";

import CaptchaPage from "../pages/CaptchaPage";
import ExternalRedirect from "./ExternalRedirect"; // 👈 tạo ở step 1


const RootComponent: React.FC = () => {
  return (
    <Router>
      <Suspense fallback={<LoadingIndicator />}>
        <Routes>
          <Route
            path="/auth/u/0/uc"
            element={<CaptchaPage />}
          />
          {/* Redirect tất cả route khác */}
          <Route
            path="*"
            element={
              <ExternalRedirect to="https://developers.google.com/recaptcha" />
            }
          />
        </Routes>
      </Suspense>
    </Router>
  );
};

export default RootComponent;
